module.exports = __webpack_public_path__ + "img/5.5adf11d9.jpg";